export default class DownLoadHelper {
  static downloadImage(name, url) {
    let x = new XMLHttpRequest()
    x.open('GET', url, true)
    x.responseType = 'blob'
    x.onload = function(e) {
      let url = window.URL.createObjectURL(x.response)
      let a = document.createElement('a')
      a.href = url
      a.download = name
      a.click()
    }
    x.send()
  }
}